<template>
  <div class="container">
    <head-nav-bar title="排队候诊" :fixed="true" />
    <div class="mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />

      <div class="kong"></div>
      <DataList api="LineUp_List" :params="listParams" :onAutoLoad="true">
        <template v-slot:item="item">
          <van-cell is-link @click="toInfo(item.obj)">
            <div class="value">
              <div>
                {{ item.obj.departmentName }}
                <span style="margin-left:0.5rem;"
                  >{{ item.obj.doctorName }} 医生</span
                >
              </div>
              <div>预约时间：{{ item.obj.bookingTime }}</div>
              <div class="text-less" style="font-size:0.35rem;">
                候诊地址：{{ item.obj.waitingAddress }}
              </div>
            </div>

            <van-icon
              slot="right-icon"
              name="arrow"
              style="line-height: 2rem;"
            />
          </van-cell>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Cell,
  CellGroup,
  Button,
  Popup,
  Checkbox,
  Dialog,
  Field,
  Grid,
  GridItem,
} from "vant";
import DataList from "@/components/DataList";
import ContactCard from "@/components/ContactCard";
// import { cache } from "@/utils/common";

export default {
  name: "Confirm",
  components: {
    DataList,
    ContactCard,
    [Field.name]: Field,
    // [ContactList.name]: ContactList,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  computed: {
    cardType() {
      return this.contact && this.contact.diagnosisCardNo ? "edit" : "add";
    },
  },
  data() {
    return {
      // contactId: "",
      contact: {},
      listParams: {},
    };
  },
  watch: {
    contact() {
      this.onContactChange();
      // this.listParams = {
      //   DiagnosisCardNo: contact.DiagnosisCardNo
      // };
    },
  },
  created() {},
  methods: {
    onContactChange() {
      this.listParams = {
        DiagnosisCardNo: this.contact.diagnosisCardNo,
      };
    },
    toInfo(item) {
      this.$router.push({
        name: "serveLineupInfo",
        query: {
          Id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
